module.exports = __webpack_public_path__ + "img/logo.70453e13.svg";